import { AdditionalTestTranslations } from "./types";

export const deTranslations: AdditionalTestTranslations = {
    testLabel: " Zusätzliche Tests anfordern",
    professional: "Berufsgruppe auswählen",
    professionalOptions: [
        { value: "PHYSIO", label: "Zusätzliche Tests wurden angefordert" },
        { value: "NURSE", label: "Pflegepersonal" },
    ],

    deailedInspection: "3-Seiten-Inspektion",
    detailedInspectionCheckbox: [
        { name: "ANTERIOR_VIEW", label: "Frontansicht" },
        { name: "POSTERIOR_VIEW", label: "Rückansicht" },
        { name: "SIDE_VIEW", label: "Seitenansicht" },
    ],
    specialTests: "Provokationstests",
    specialTestsCheckbox: [
        { name: "SLR", label: "Lasegué-Zeichen" },
        { name: "STEINMANN", label: "Steinman 1-Zeichen" },
        { name: "FABERS_SIGN", label: "Vierer-Zeichen" },
    ],
    clinicalPrediction: "Klinische Vorhersageregeln",
    clinicalPredictionCheckbox: [
        { name: "OTTAWA_ANKLE", label: "Ottawa- Sprunggelenksregeln" },
        { name: "OTTAWA_KNEE", label: "Ottawa-Knieregeln" },
        { name: "AMSTERDAM_WRIST", label: "Amsterdam-Handgelenksregeln" },
    ],
    mobility: "Mobilität",
    mobilityCheckbox: [
        { name: "AID_ASSESSMENT", label: "Hilfsmittelbedarf" },
        { name: "STAIR_ASSESSMENT", label: "Treppen steigen" },
        { name: "GAIT_ANALYSIS", label: "Ganganalyse" },
        { name: "ADL_ASSESSMENT", label: "Aktivitäten des täglichen Lebens" },
    ],
    adlAssessment: "ADL-Fähigkeit",
    adlRelatedAssessment: [
        { name: "TIP_TOEING", label: "Zehenstand" },
        { name: "SQUAT", label: "Kniebeuge" },
        { name: "SINGLE_LEG_STANCE", label: "Einbeinstand" },
    ],
    reasonReferral: "Grund für Überweisung",
    summary: "Zusammenfassung",
    clearButton: "Löschen",
    submitButton:"Test anfordern",
    result:"Ergebnisse",
    pending: "Ausstehende Ergebnisse",
    available: "Verfügbare Ergebnisse",
    reportFor: "Bericht für",
    report: "Bericht",
    reviewedText: "Überprüft",
    noSummaryProvided: "Keine Zusammenfassung vorhanden",
    noReasonProvided: "Kein Grund angegeben",
    noFindings: "Keine Erkenntnisse verfügbar",
    notes: "Notizen",
    noNotes: "Keine Notizen verfügbar",
    notesPlaceholder: "Fügen Sie hier Notizen hinzu...",
    Physio: "Zusätzliche Tests wurden angefordert",
    Nurse: "Zusätzliche Tests wurden angefordert",
    viewReport: "Ergebnisse ansehen",
};
